import PropTypes from "prop-types";

import StyledIcon from "./styles";

const Icon = (props) => {
  const { className, name, size, color, ...restProps } = props;

  const iconName = `ri-${name}`;
  const iconSize = size ? `ri-${size}` : "";

  // combine icon name and icon size
  const classNames = `${className || ""} ${iconName} ${iconSize}`.trim();

  return (
    <StyledIcon
      role="icon"
      className={classNames}
      colorFunc={color}
      {...restProps}
    />
  );
};

export default Icon;

// declare prop types
Icon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  color: PropTypes.func,
  size: PropTypes.oneOf([
    "fw",
    "xxs",
    "xs",
    "sm",
    "1x",
    "lg",
    "xl",
    "2x",
    "3x",
    "4x",
    "5x",
    "6x",
    "7x",
    "8x",
    "9x",
    "10x",
  ]),
};
